const dateConstants = {
  DATE_FORMAT_ES: 'dd/MM/yyyy',
  DATE_FORMAT_EN: 'MM/dd/yyyy',
}

export const weekDays = {
  MONDAY: 'monday',
  TUESDAY: 'tuesday',
  WEDNESDAY: 'wednesday',
  THURSDAY: 'thursday',
  FRIDAY: 'friday',
  SATURDAY: 'saturday',
  SUNDAY: 'sunday',
}
export const weekEnd = {
  SATURDAY: 'saturday',
  SUNDAY: 'sunday',
}
export const weekWork = {
  MONDAY: 'monday',
  TUESDAY: 'tuesday',
  WEDNESDAY: 'wednesday',
  THURSDAY: 'thursday',
  FRIDAY: 'friday',
}

export const selectDays = {
  ALL: 'days',
  WEEKWORK: 'weekWork',
  WEEKEND: 'weekEnd',
}

export default dateConstants
